import { SliceType } from '../types';

import type { DigestHighlightsSliceType } from './types';

export const defaultDigestSlice: DigestHighlightsSliceType = {
  id: 'default',
  name: 'Default Slice',
  docURL: '...',
  version: 'sktwi1xtmkfgx8626',
  description: 'Digest Highlights Slice',
  primary: {},
  items: [],
  slice_type: SliceType.DigestHighlightsSlice,
};
